import _ from 'lodash';
import SalesService from "../../sales/SalesService";
import TelephoneBidSearch from "@/modules/telephone-bids/models/TelephoneBidSearch.model";
import BiddersService from "@/modules/bidders/BiddersService";
import LotsService from "@/modules/lots/LotsService";
import TelephoneBidsService from "@/modules/telephone-bids/TelephoneBidsService";
import {store} from "@/plugins/vuex";
import {TELEPHONE_BIDS_TABLE_NAME} from "@/modules/constants";

let getDefaultTableData = () => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-created_at',
    search: '',
    searchModel: new TelephoneBidSearch(),
    extraFilters: {}
  }
};

export default {
  namespaced: true,
  state: {
    modal: {
      show: false,
      object: null,
      source: null
    },
    manageClerksModal: {
      show: false,
      object: null,
      source: null
    },
    assignClerksModal: {
      loading: false,
      show: false,
      object: null,
      source: null,
      telephoneBids: [],
    },
    tableSource: null,
    tableData: {
      sale: getDefaultTableData()
    },
    viewBy: 'bidder'
  },
  actions: {
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: currentTableData,
        tableName: TELEPHONE_BIDS_TABLE_NAME
      });

      if (payload) {
        data = {...payload.pagination, search: payload.search, ordering: payload.ordering,};
      } else {
        data = {...currentTableData.pagination, search: currentTableData.search, ordering: ordering}
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {...data, ...searchModelData}
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }
      if (state.viewBy === 'bidder') {
        data.expand = 'customer,language,preferred_clerk,telephone_bids.lot.inventory,lot,bidder,telephone_bids.clerk';
      } else {
        data.expand = 'inventory,telephone_bids.bidder.customer,telephone_bids.bidder.language,telephone_bids.bidder.preferred_clerk,telephone_bids.clerk';
      }

      return data;
    },
    async getTableData({state, commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);
      let response = null;
      commit('updateTableLoading', true);
      if (state.viewBy === 'bidder') {
        response = await BiddersService.getBidders(params);
      } else {
        response = await LotsService.getLots(params);
      }
      commit('updateTableLoading', false);
      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }
      return response;
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = {
        ...state.tableData[state.tableSource],
        ...defaultTableData
      };
      state.tableData[state.tableSource].extraFilters = extraFilters;
      dispatch('getTableData');
    },
    async updateTableSource({state}, {extraFilters, source, sale}) {
      state.tableSource = source;
      state.tableData[source].extraFilters = extraFilters;
      state.tableData[source].sale = _.cloneDeep(sale);
    },
    async updateTableViewBy({state}, viewBy) {
      state.viewBy = viewBy;
    },
    showModal({commit}, {object = null, source, sale} = {}) {
      commit('showModal', {object: _.cloneDeep(object), source, sale});
    },
    hideModal({commit}) {
      commit('hideModal');
    },
    showManageClerksModal({commit}, {object = null, source} = {}) {
      commit('showManageClerksModal', {object: _.cloneDeep(object), source});
    },
    hideManageClerksModal({commit}) {
      commit('hideManageClerksModal');
    },
    showAssignClerksModal({commit}, {object = null, source} = {}) {
      commit('showAssignClerksModal', {object: _.cloneDeep(object), source});
    },
    hideAssignClerksModal({commit}) {
      commit('hideAssignClerksModal');
    },
    async createTelephoneBid({dispatch}, payload) {
      let response = await TelephoneBidsService.createTelephoneBid(payload, 'bidder.language,bidder.preferred_clerk');
      if (response.success) {
        dispatch('getTableData')
      }
      return response;
    },
    async updateTelephoneBid({dispatch}, payload) {
      let response = await TelephoneBidsService.updateTelephoneBid(payload);
      if (response.success) {
        dispatch('getTableData')
      }
      return response;
    },
    async removeTelephoneBids({dispatch}, payload) {
      let response = await TelephoneBidsService.batchRemoveTelephoneBid(payload);
      if (response.success) {
        dispatch('getTableData')
      }
      return response;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new TelephoneBidSearch({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    async updateBidder({dispatch}, payload) {
      let response = await BiddersService.partialUpdateBidder(payload.uuid, payload);
      if (response.success) {
        dispatch('getTableData');
      }
      return response;
    },
    async updateSaleClerks({commit}, payload) {
      let response = await SalesService.partialUpdateSale(payload.uuid, {clerks_uuids: payload.selectedClerks}, 'clerks.languages')
      if (response.success) {
        commit('updateSaleClerks', response.body);
      }
      return response;
    },
    async getTelephoneBidsData({state, commit}, params) {
      commit('updateAssignClerksModalLoading', true);
      let response = await TelephoneBidsService.getTelephoneBids(params.auction_uuid);
      if (response.success) {
        commit('updateAssignClerksModalLoading', false);
        commit('updateAssignClerksModalData', response.body.results);
      }
    },
    async saveAssignedClerks({state, commit, dispatch}, data) {
      let response = await SalesService.partialUpdateSale(data.sale_uuid, {telephone_bids_lot_spacing: data.telephone_bids_lot_spacing}, 'clerks,currency');
      if (response.success) {
        commit('updateSale', response.body);
        let updateResponse = await TelephoneBidsService.batchUpdateTelephoneBids(data.requestData);
        if (updateResponse.success) {
          dispatch('getTableData');
        }
        return updateResponse;
      }
      return response;
    },
    async updateAssignClerksModalLoading({commit}, payload) {
      commit('updateAssignClerksModalLoading', payload);
    }
  },
  mutations: {
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateAssignClerksModalLoading: (state, payload) => state.assignClerksModal.loading = payload,
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {...state.tableData[state.tableSource], ...payload},
    showModal: (state, {object, source, sale}) => {
      state.modal.show = true;
      state.modal.object = object;
      state.modal.source = source;
      state.modal.sale = sale;
    },
    hideModal: state => state.modal.show = false,
    showManageClerksModal: (state, {source, object}) => {
      state.manageClerksModal.show = true;
      state.manageClerksModal.source = source;
      state.manageClerksModal.object = object
    },
    hideManageClerksModal: state => state.manageClerksModal.show = false,
    showAssignClerksModal: (state, {source, object}) => {
      state.assignClerksModal.show = true;
      state.assignClerksModal.source = source;
      state.assignClerksModal.object = object
    },
    hideAssignClerksModal: state => state.assignClerksModal.show = false,
    updateSearchModel: (state, searchModel) => state.tableData[state.tableSource].searchModel = searchModel,
    updateSaleClerks: (state, data) => state.tableData[state.tableSource].sale = {...data},
    updateSale: (state, data) => state.tableData[state.tableSource].sale = {...data},
    updateAssignClerksModalData: (state, payload) => {
      state.assignClerksModal.telephoneBids = payload;
    },
  }
}
